export default (backboneMarket) => {
  const { component_translations: translations } = backboneMarket;
  return { translations };
};
